import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts'
import { useSeasonStats } from '@/lib/hooks'

export function SeasonChart({ teamId }: { teamId: string }) {
  const { data = [] } = useSeasonStats(teamId)
  return (
    <div className="rounded-lg bg-muted/30 p-4">
      <div className="text-[10px] uppercase tracking-widest text-muted-foreground mb-3">Season Goals · For vs Against</div>
      <div className="h-40">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ left: 0, right: 4, top: 4, bottom: 0 }}>
            <defs>
              <linearGradient id="gfGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#1CA84A" stopOpacity={0.55} />
                <stop offset="100%" stopColor="#1CA84A" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="gaGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#F5C518" stopOpacity={0.45} />
                <stop offset="100%" stopColor="#F5C518" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
            <XAxis dataKey="month" tick={{ fill: 'hsl(var(--muted-foreground))', fontSize: 11 }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fill: 'hsl(var(--muted-foreground))', fontSize: 11 }} axisLine={false} tickLine={false} width={20} />
            <Tooltip
              contentStyle={{
                background: 'hsl(var(--popover))',
                border: '1px solid hsl(var(--border))',
                borderRadius: 8,
                fontSize: 12,
              }}
              labelStyle={{ color: 'hsl(var(--foreground))', fontWeight: 600 }}
            />
            <Area type="monotone" dataKey="gf" stroke="#1CA84A" strokeWidth={2} fill="url(#gfGrad)" name="Goals For" />
            <Area type="monotone" dataKey="ga" stroke="#F5C518" strokeWidth={2} fill="url(#gaGrad)" name="Goals Against" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}
